"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerStreamPreviewContainer = exports.fadeInDurationInMilliseconds = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var Curves_1 = require("icf-search-client-shared/lib/Curves");
var react_1 = require("react");
var react_jss_1 = __importDefault(require("react-jss"));
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var StreamPreviewPlayerWrapper = (0, react_jss_1.default)({
    streamPreviewPlayerWrapper: {
        height: "100%",
        objectFit: "cover",
        opacity: function (_a) {
            var isPlaying = _a.isPlaying;
            return (isPlaying ? 1 : 0);
        },
        overflow: "hidden",
        transform: "rotate(0.0001deg)",
        transitionDuration: "500ms",
        transitionProperty: "opacity",
        width: "100%",
        "& video": {
            height: "100%",
            objectFit: "cover",
            width: "100%",
        },
    },
})((0, react_1.forwardRef)(function (_a, ref) {
    var classes = _a.classes, isPlaying = _a.isPlaying, props = __rest(_a, ["classes", "isPlaying"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.streamPreviewPlayerWrapper, ref: ref }, props)));
}));
var StreamPreviewMouseEventingGuard = (0, react_jss_1.default)({
    streamPreviewMouseEventingGuard: {
        top: "0",
        width: "100%",
        height: "100%",
        position: "absolute",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.streamPreviewMouseEventingGuard }, props));
});
exports.fadeInDurationInMilliseconds = 3000;
var rolloverEventName = "searchRolloverV1";
var rolloverEventType = "icfClick";
var PerformerStreamPreviewContainer = /** @class */ (function (_super) {
    __extends(PerformerStreamPreviewContainer, _super);
    function PerformerStreamPreviewContainer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._player = null;
        _this._currentFade = null;
        _this._playerRef = function (element) {
            if (!element) {
                return;
            }
            _this._createPlayer(element);
        };
        _this.state = {
            isLoading: props.streamPlayerFactory.streamingAvailable,
            isPlaying: false,
            error: null,
        };
        return _this;
    }
    PerformerStreamPreviewContainer.prototype._videoFirstPlayEvent = function () {
        var _this = this;
        if (!this._player) {
            return;
        }
        if (this.props.streamPlayerFactory.canFadePlayerVolume(this._player)) {
            this._currentFade = (0, Curves_1.createFadeIn)(exports.fadeInDurationInMilliseconds, function (volume, complete) {
                if (!_this._player) {
                    _this._currentFade.dispose();
                    return;
                }
                _this._player.localAudioVolume = volume;
                if (complete) {
                    _this._currentFade = null;
                }
            });
        }
        if (this.props.statsdClient) {
            this.props.statsdClient.count("performerItem.rollover");
        }
        this.setState({ isLoading: false, isPlaying: true, error: null });
        this._emitAnonRolloverEvent();
        if (this.props.onPlaying) {
            this.props.onPlaying();
        }
    };
    PerformerStreamPreviewContainer.prototype._errorEvent = function (error) {
        if (this._currentFade) {
            this._currentFade.dispose();
        }
        this.setState({ isLoading: false, isPlaying: false, error: error });
        if (this.props.onError) {
            this.props.onError(error);
        }
    };
    PerformerStreamPreviewContainer.prototype._attachEvents = function (player) {
        player.on("error", this._errorEvent.bind(this));
        player.on("videoFirstPlay", this._videoFirstPlayEvent.bind(this));
    };
    PerformerStreamPreviewContainer.prototype._createPlayer = function (element) {
        if (this._player || !this.props.streamPlayerFactory.streamingAvailable) {
            return;
        }
        this._player = this.props.streamPlayerFactory.createPlayer(this.props.userData.id, this.props.performerData.nickname, element);
        this._player.localAudioMuted = !this.props.isSoundEnabled;
        if (this.props.onLoading) {
            this.props.onLoading();
        }
        if (this._player) {
            this._attachEvents(this._player);
        }
    };
    PerformerStreamPreviewContainer.prototype._emitAnonRolloverEvent = function () {
        if (this.props.performerData.id && this.props.emitTrackingEvent) {
            this.props.emitTrackingEvent(rolloverEventType, rolloverEventName, "performerId=".concat(this.props.performerData.id, "&label=").concat(this.props.isMobile ? "mobile" : "desktop"));
        }
    };
    PerformerStreamPreviewContainer.prototype._disposePlayer = function () {
        if (!this._player) {
            return;
        }
        this._player.off("videoFirstPlay", this._videoFirstPlayEvent);
        this._player.off("error", this._errorEvent);
        this._player.dispose("search.client PerformerStreamPreviewContainer called dispose");
        this._player = null;
    };
    PerformerStreamPreviewContainer.prototype.componentWillUnmount = function () {
        if (this._currentFade) {
            this._currentFade.dispose();
        }
        this._disposePlayer();
    };
    PerformerStreamPreviewContainer.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(StreamPreviewPlayerWrapper, { "data-ta-locator": "stream_preview", isPlaying: this.state.isPlaying, ref: this._playerRef }), (0, jsx_runtime_1.jsx)(StreamPreviewMouseEventingGuard, {}), this.props.children ? this.props.children(__assign({}, this.state)) : null] }));
    };
    PerformerStreamPreviewContainer.prototype.componentDidCatch = function (error, errorInfo) {
        this._disposePlayer();
        // This is always true in the test environment.
        /* istanbul ignore next */
        if (_super.prototype.componentDidCatch) {
            _super.prototype.componentDidCatch.call(this, error, errorInfo);
        }
    };
    PerformerStreamPreviewContainer = __decorate([
        (0, Ioc_1.connectContextsToProps)({
            streamPlayerFactory: Contexts_1.IStreamPlayerFactoryContext,
        })
    ], PerformerStreamPreviewContainer);
    return PerformerStreamPreviewContainer;
}(React.PureComponent));
exports.PerformerStreamPreviewContainer = PerformerStreamPreviewContainer;
//# sourceMappingURL=PerformerStreamPreviewContainer.js.map